import { render, staticRenderFns } from "./BlockCover.vue?vue&type=template&id=28a96586&scoped=true"
import script from "./BlockCover.vue?vue&type=script&lang=js"
export * from "./BlockCover.vue?vue&type=script&lang=js"
import style0 from "./BlockCover.vue?vue&type=style&index=0&id=28a96586&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a96586",
  null
  
)

export default component.exports